import { Card, Col, Row } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import ProfileAccount from 'components/profileAccount';
import ProfileNotification from 'components/profileNotification';
import ProfileSubscription from 'components/profileSubscription';
import React from 'react';
import classes from './style.module.scss';

const ProfilePage = () => {
  const { md } = useBreakpoint();
  return (
    <>
      <div className={classes.content} style={{ padding: md ? 16 : 0 }}>
        <Row>
          <Col md={12} xs={24} style={{ paddingRight: md ? 8 : 0 }}>
            <Card title="Account" className={classes.profileCard}>
              <ProfileAccount />
            </Card>
            <Card title="My Smart Cams" className={classes.profileCard}>
              <ProfileSubscription />
            </Card>
          </Col>
          <Col md={12} xs={24} style={{ paddingLeft: md ? 8 : 0 }}>
            <Card title="Email/Push notification Setting" className={classes.profileCard}>
              <ProfileNotification />
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ProfilePage;
